import { updateNodeStates } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch } from "@builder/store/store";
import { useOutsideClick } from "@common/hooks/useOutsideClick";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";
import classNames from "classnames";
import { NodeStates } from "@common/build/types";

const allStateOptions = Object.values(NodeStates);

interface StateSelectorProps {
    nodeId: string;
    state?: NodeStates;
    stateOptions?: NodeStates[];
}

const StateSelector = ({ nodeId, state, stateOptions }: StateSelectorProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [stateSelectorOpen, setStateSelectorOpen] = useState<boolean>(false);
    const selectorRef = useRef<HTMLDivElement>(null);

    useOutsideClick(selectorRef, () => setStateSelectorOpen(false));

    const handleOptionClick = (newState: NodeStates) => {
        if (state !== newState) {
            dispatch(updateNodeStates({ [nodeId]: newState }));
        }
        setStateSelectorOpen(false);
    };

    const selectWrapperClass = classNames("state-input-wrapper", {
        ["active"]: stateSelectorOpen,
        ["background-change"]: state && state !== NodeStates.DEFAULT
    });

    return (
        <div className="state-selector-wrapper" ref={selectorRef}>
            <div className={selectWrapperClass} onClick={() => setStateSelectorOpen(!stateSelectorOpen)}>
                <input type="text" readOnly value={t(`nodeStates.${state || NodeStates.DEFAULT}`)} />
                <img src="./angled-arrow-down.svg" alt="" style={{ transform: stateSelectorOpen ? "rotate(-180deg)" : undefined }} />
            </div>
            {stateSelectorOpen && (
                <div className="state-options-wrapper">
                    {(stateOptions || allStateOptions).map((stateOption, index) => (
                        <div className="state-option" key={index} onClick={() => handleOptionClick(stateOption)}>
                            <p>{t(`nodeStates.${stateOption}`)}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default StateSelector;
